import React from "react";
import './packageCard.scss';

interface CardProps {
    icon: any,
    text: string
}

export const PackageCard: React.FC<CardProps> = ({icon, text}) => {
    return (
        <div className={'package-card'}>
            <img src={icon} alt=""/>
            <p>{text}</p>
        </div>
    );
};

// export default PackageCard;